import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  ApproveOrRejectFlexiReiumbersementClaimInput,
  ApproveOrRejectFlexiReiumbersementClaimResponse,
  ApproveOrRejectFlexiReiumbersementClaimVariables,
} from 'api/gql-utils/flexibleBenefits/types';

const approveOrRejectFlexiReiumbersementClaimMutation = gql`
  mutation PayrollFlexiReimbursementClaimApproveOrReject(
    $input: ChangePendingFBPClaimStatusInput!
  ) {
    payrollFlexiReimbursementClaimApproveOrReject(input: $input) {
      claim {
        claim_id
        tenant_id
        merchant_id
        component_id
        assignment_id
        expense_date
        employee_id
        claim_amount
        approved_amount
        claim_description
        claim_evidence_id
        claim_status
        claim_comments
        last_modified_by
        created_at
        updated_at
        component_display_name
      }
      code
      success
      message
    }
  }
`;

export const approveOrRejectFlexiReiumbersementClaim = (
  input: ApproveOrRejectFlexiReiumbersementClaimInput,
) => {
  return graphQLApi<
    ApproveOrRejectFlexiReiumbersementClaimResponse,
    ApproveOrRejectFlexiReiumbersementClaimVariables
  >({
    query: approveOrRejectFlexiReiumbersementClaimMutation,
    queryVariables: { input },
  });
};
